import PaymentFailure from './paymentFailure'
export default PaymentFailure
